import React, { Component } from 'react';
import { Container, Row, Col, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { StatsCard } from '../StatsCard/StatsCard';
import { Card } from '../Card/Card';
import CountUp from 'react-countup';
import { getCurrentProfile } from '../../actions/profileAction';
import Spinner from '../common/Spinner';
import isEmpty from '../../validation/is-empty';
import { createClient, getParticipants, getNumOfParticipants, getConferenceById } from '../../actions/clientActions';

import { Slide } from 'react-awesome-reveal';

var dateFromObjectId = function (objectId) {
  return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
};

class ConferenceTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      student: '',
      conferenceFullName: '',
      speakerFullName: '',
      errors: {}
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params._id) {
      const _id = this.props.match.params._id
      this.props.getConferenceById(_id);
      this.props.getNumOfParticipants(_id);
      this.props.getParticipants(_id);
      this.props.getCurrentProfile();
    }
  }

  onSubmit(e) {
    e.preventDefault();
    const newParticipant = {
      _id: this.state._id,
      student: this.state.student,
    }
    this.props.createClient(newParticipant);
    this.setState({ student: '' })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }

    if (nextProps.conference.conference) {
      const conference = nextProps.conference.conference;

      conference._id = !isEmpty(conference._id) ? conference._id : '';
      conference.conferenceFullName = !isEmpty(conference.conferenceFullName) ? conference.conferenceFullName : '';
      conference.speakerFullName = !isEmpty(conference.speakerFullName) ? conference.speakerFullName: '';
      // Set component fields state
      this.setState({
        _id: conference._id,
        conferenceFullName: conference.conferenceFullName,
        speakerFullName: conference.speakerFullName,
      });
    }
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const { loading } = this.props.student;
    const students = this.props.participant.participants;
    const numOfparticipants = this.props.participant.countParticipantsByConference;
    let num = 0;
    if (numOfparticipants < 1) { }
    else {
      num = numOfparticipants[0].count;
    }
    let studentItems;
    if (students === null || loading) {
      studentItems = (
        <tr>
          <td>
            <Spinner />
          </td>
        </tr>
      );
    }

    else {
      if (students.length > 0) {
        studentItems = students?.map(student => (
          <tr key={student._id}>
            <td style={{ border: '0px' }}>{student.name}</td>
            <td style={{ border: '0px' }}>{student.student}</td>
            <td>{dateFromObjectId(student._id).toLocaleDateString("en-GB")} {dateFromObjectId(student._id).toLocaleTimeString("en-GB")}</td>
          </tr>

        ));
      }
      else {
        studentItems = (
          <tr>
            <td>Jos uvek nisu cekirani delegati za ovo predavanje</td>
          </tr>
        );
      }
    }

    return (
      <div className="content">
      <Slide triggerOnce>
        <Row className='justify-content-center'>
          <Col md={6} style={{ textAlign: 'center' }}> 
            <Card
              title={this.state.conferenceFullName}
              category={this.state.speakerFullName}
            />
          </Col>
        </Row>
        <Row className='justify-content-center'>
          <Col lg={3} sm={3}>
            <StatsCard
              bigIcon={<i className="pe-7s-id" />}
              statsText="Delegata"
              statsValue={
                <CountUp
                  className="account-balance"
                  start={0}
                  end={num}
                  duration={2}
                  useGrouping={true}
                />}
            />
          </Col>
        </Row>
</Slide>
        <Container fluid>
          <Row>
            <Col md={12}>
              <form onSubmit={this.onSubmit}>
                <input
                  className="form-control form-control-lg col-md-4"
                  placeholder="Skenirajte QR kod delegata"
                  name="student"
                  type="email"
                  autoFocus
                  value={this.state.student}
                  onChange={this.onChange}
                />
              </form>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card
                title="Delegati"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover bordered >
                    <thead>
                      <tr>
                        <th style={{ border: '0px' }}>Ime i prezime</th>
                        <th style={{ border: '0px' }}>Email adresa</th>
                        <th style={{ border: '0px' }}>Vreme prisustva</th>
                      </tr>
                    </thead>
                    <tbody>{studentItems}</tbody>
                  </Table>
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

ConferenceTemplate.propTypes = {
  student: PropTypes.object.isRequired,
  participant: PropTypes.object.isRequired,
  getCurrentProfile: PropTypes.func.isRequired,
  createClient: PropTypes.func.isRequired,
  getParticipants: PropTypes.func.isRequired,
  getNumOfParticipants: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  conference: PropTypes.object.isRequired,
  getConferenceById: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  conference: state.conference,
  student: state.student,
  participant: state.participant,
  auth: state.auth,
});

export default connect(
  mapStateToProps,
  { getCurrentProfile, createClient, getParticipants, getNumOfParticipants, getConferenceById }
)(ConferenceTemplate);
